import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import "../styles/MateriaContenido.css";
import TemaItem from "./TemaItem";
import { getMateriaData } from "../services/materiaService";
import Modal from "./Modal";
import BottomMenu from "./BottomMenu";
import { getRandomLottie } from "../services/lottieService";
import Cuestionario from "./Cuestionario";
import { datosMock } from "../utils/datosMock";
import ReporteCalificacion from "./ReporteCalificacion";
import { getEvaluacionTemaData } from "../services/materiaService";

export function MateriaContenido({ materia, calificaciones, fontColor,
  onVolver, selectedTema, setSelectedTema, user, setModo, refrescarDatosUsuario }) {
  const partes = materia.contenido.split("-");
  const [temas, setTemas] = useState([]);
  const [randomLottie, setRandomLottie] = useState(null);
  const [mostrarEvaluacion, setMostrarEvaluacion] = useState(false);
  const [datosEvaluacion, setDatosEvaluacion] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const data = await getMateriaData(materia.id);
      setTemas(data.temas || []);
    };

    fetchData();
  }, [materia.id]);


  useEffect(() => {
    //console.log("selectedTema en MateriaContenido:", selectedTema);
    if (selectedTema) {
      setRandomLottie(getRandomLottie());
    } else {
      /*if (typeof setIsModalOpen === "function") {
        console.log("Avisando a Layout: cerrar modal");
        setIsModalOpen(false);
      }*/
    }
  }, [selectedTema]);

  useEffect(() => {
    const fetchEvaluacion = async () => {
      if (selectedTema) {
        //console.log("Contenido de selectedTema47: ", selectedTema);
        const data = await getEvaluacionTemaData(selectedTema.codigo);
        setDatosEvaluacion(data);
      } else {
        setDatosEvaluacion(null);
      }
    };
    fetchEvaluacion();
  }, [selectedTema]);


  // Agrupamos por unidades
  const unidades = [];
  let unidadActual = null;
  partes.forEach((item) => {
    if (item.length > 4) {
      unidadActual = { titulo: item, temas: [] };
      unidades.push(unidadActual);
    } else if (unidadActual) {
      unidadActual.temas.push(item);
    }
  });

  let contadorTemas = 1;

  if (mostrarEvaluacion && selectedTema) {
    return (
      <Cuestionario
        datosFirebase={datosEvaluacion}
        colorPrincipal={fontColor}
        onFinalizar={() => {
          setMostrarEvaluacion(false);   // cerramos cuestionario
          setSelectedTema(null);         // cerramos modal
        }}
        setModo={setModo}
        user={user}
        selectedTema={selectedTema}
        refrescarDatosUsuario={refrescarDatosUsuario} />
    );
  }

  return (
    <div className="materia-contenido">
      <button onClick={onVolver} className="btn-volver w-100 btn btn-success">
        ← Volver a las materias
      </button>

      <h2 style={{ color: fontColor }}>{materia.title}</h2>

      {unidades.map((unidad, idx) => (
        <div key={idx} className="unidad" >
          <h3 style={{ color: fontColor }}>
            Unidad {idx + 1}: {unidad.titulo}
          </h3>
          <ul>
            {unidad.temas.map((codigo) => {
              // Buscar el tema parseado en el estado `temas`
              const tema = temas.find((t) => t.codigo === codigo);

              // Calificación
              const valor = calificaciones[codigo];
              const nota = valor ? parseInt(valor.split("@@")[0], 10) : null;

              const numeroTema = contadorTemas++;
              //console.log("-Tema: ", tema?.titulo, "-Código: ", tema?.codigo);
              return (
                <li key={codigo} onClick={() => {
                  if (typeof setSelectedTema === "function") {
                    setSelectedTema(tema);
                  } else {
                    console.error("setSelectedTema no es función", setSelectedTema);
                  }
                }}>
                  <TemaItem
                    tema={tema}
                    calificacion={nota}
                    fontColor={fontColor}
                    numero={numeroTema}
                    codigo={codigo}
                    user={user}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      ))
      }

      {/* Modal dinámico */}
      <Modal isOpen={!!selectedTema} onClose={() => setSelectedTema(null)}>
        {selectedTema && (
          <>
            {randomLottie && (
              <div className="modal-lottie">
                <Lottie animationData={randomLottie} loop={true} style={{ height: 120 }} />
              </div>
            )}
            <h5 className="mb-0" style={{ textAlign: "center", color: fontColor }}>
              {materia.title}
            </h5>
            <h4 className="modal-title"
              style={{ textAlign: "center", color: fontColor }}>
              {selectedTema.titulo}
            </h4>
            <div className="btn-group">
              <a className={`btn btn-primary ${selectedTema.url && selectedTema.url.includes('.') ? '' : 'disabled'}`}
                href={selectedTema.url && selectedTema.url.includes('.') ? selectedTema.url : '#'}
              >
                {selectedTema.url.includes('.') ? 'Clase' : "Clase no disponible"}

              </a>
              <button className={`btn btn-secondary 
                ${selectedTema.url && selectedTema.url.includes('.') ? '' : 'disabled'}`}
                onClick={() => {
                  setSelectedTema(selectedTema);   // guardamos el tema
                  setMostrarEvaluacion(true);      // activamos cuestionario
                }}
              >
                {selectedTema.url.includes('.') ? 'Evaluación' : "Evaluación no disponible"}
              </button>
            </div>
            {/*}
            {selectedTema.url && (
              <p>
                Recurso: <a href={selectedTema.url}>{selectedTema.url}</a>
              </p>
            )}
              {*/}
          </>
        )}
      </Modal>
      {/*}
      <BottomMenu isModalOpen={!!selectedTema} />
      {*/}
    </div >
  );
}
